import React, { useState } from 'react'

import {
    Grid,
    Button,
    Dialog,
    DialogContent,
    useTheme,
    useMediaQuery,
    TextField
} from "@material-ui/core";
import DynamicInput from '../InputComponents/DynamicInput';
import { formatDecimals } from '../dummyConstant/DummyConstant';
import moment from 'moment-timezone';

const PayDetailsModal = ({ upadteModalPay }) => {
    const theme = useTheme();

    let { openModalPay, closePayModal, paytypeDropdown, setUpdatePay, updatePay, onUpdatePay, setUpdatePayDate, updatePayDate } = upadteModalPay;

    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    let fields_1 = [
        { type: 1, name: "Employee ID", isRequired: true, initial: updatePay?.employee_id, isDisabled: true },
        { type: 3, key: 'title', isRequired: true, initial: updatePay?.pay_type, options: paytypeDropdown, name: "Pay Type", onChange: (newValue) => setUpdatePay({ ...updatePay, pay_type: newValue }) },
        // { type: 1, name: "Pay Rate", isRequired: true, initial: updatePay?.rate, fieldType: 'number', mode: 'decimal', onChange: (value) => setUpdatePay({ ...updatePay, rate: value }) },
    ]
    let fields_2 = [
        {
            type: 2,
            name: "Updated Date",
            isRequired: true,
            // initial: updatePay?.task === 'add' ? null : new Date(updatePay?.updatedAt),
            initial: updatePay?.updatedAt,
            onChange: (value) => { setUpdatePay({ ...updatePay, updatedAt: (value) }) }
        },
        // { type: 1, name: "Vehicle Allowance Amount", fieldType: 'number', isRequired: true, initial: updatePay?.vehicle_allowance, onChange: (value) => setUpdatePay({ ...updatePay, vehicle_allowance: value }) },

    ]

    const handlePayRate = (value) => {

        const regex = /[a-zA-Z]/

        if (!regex.test(value)) {

            let [first, sec] = value.split('.')
            if (sec?.length > 2)
                return setUpdatePay({ ...updatePay, rate: updatePay?.rate })
            return setUpdatePay({ ...updatePay, rate: value })
        }

        setUpdatePay({ ...updatePay, rate: updatePay?.rate || '' })
    }
    const handleVehicleAllowance = (value) => {

        const regex = /[a-zA-Z]/
if (!regex.test(value)) {

    let [first, sec] = value.split('.')
    if (sec?.length > 2)
        return setUpdatePay({ ...updatePay, vehicle_allowance: updatePay?.vehicle_allowance })
    return setUpdatePay({ ...updatePay, vehicle_allowance: value })
}

setUpdatePay({ ...updatePay, vehicle_allowance: updatePay?.vehicle_allowance || '' })
    }
return (
    <Dialog
        fullScreen={fullScreen}
        open={openModalPay}
        onClose={closePayModal}
        className="BroadcastMessageModal LiqTables"
        aria-labelledby="responsive-dialog-title"
    >
        <Button autoFocus onClick={closePayModal} className="ModalClose">
        </Button>
        <form onSubmit={onUpdatePay}>
            <DialogContent>
                <DynamicInput fields={fields_1} />
                <Grid xs={12} className="pl14">Pay Rate</Grid>
                <TextField
                    type='text'
                    value={updatePay?.rate}
                    defaultValue={updatePay?.rate}
                    style={{ background: 'white', borderRadius: '10px' }}
                    id="outlined-basic"
                    errorMessages={['this field is required', 'Pay rate is not valid']}
                    onChange={(e) => handlePayRate(e.target.value)}
                    required={true}

                    // error={validation ? true : false}
                    // helperText={validation != false ? validation : ""}
                    variant="outlined" className="w100p"
                />

                <Grid xs={12} className="pl14">Vehicle Allowance Amount</Grid>
                <TextField
                    type='text'
                    value={updatePay?.vehicle_allowance}
                    // defaultValue={updatePay?.vehicle_allowance}
                    style={{ background: 'white', borderRadius: '10px' }}
                    id="outlined-basic"
                    errorMessages={['this field is required', 'Pay rate is not valid']}
                    onChange={(e) => handleVehicleAllowance(e.target.value)}
                    required={true}

                    // error={validation ? true : false}
                    // helperText={validation != false ? validation : ""}
                    variant="outlined" className="w100p"
                />
                <DynamicInput fields={fields_2} />
                <Grid xs={12} container justify="center" className="mt30">
                    <Button type="submit" className="LinkButton">Save</Button>
                </Grid>
            </DialogContent>
        </form>

    </Dialog>
)
}

export default PayDetailsModal
